// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"c5b6c4ef","977":"4c0a1f69"}[chunkId] + ".chunk.js";
};